import { Home } from "./pages/Home";
import { ApprovedVendors } from "./pages/ApprovedVendors";
import { PaidVendors } from "./pages/PaidVendors";

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/approved',
        element: <ApprovedVendors />
    },
    {
        index: true,
        path: '/paid',
        element: <PaidVendors />
    }
];

export default AppRoutes;
